module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/short-black-hair-smiling/short-black-hair-smiling@1x.png"